import {CommonModule} from '@angular/common';
import {Component, EnvironmentInjector} from '@angular/core';
import {Router} from '@angular/router';
import {
  ConfigService,
  ProcessTefcaDirectAuthorizationResults,
  SourceCredentialType,
} from '@shared-library';
import {
  FdkButtonComponent,
  FdkCardComponent,
  FdkSpinnerComponent,
} from 'fasten-design-kit';
import {NGXLogger} from 'ngx-logger';

import {FastenService} from '../../services/fasten.service';

const DEFAULT_SOURCE_LOGO_BRAND_ID = 'ee170dc1-d2ef-4dfa-a2fb-b30335244aa6';

@Component({
  selector: 'app-confirm-health-system-selection',
  templateUrl: './confirm-health-system-selection.component.html',
  styleUrls: ['./confirm-health-system-selection.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FdkButtonComponent,
    FdkCardComponent,
    FdkSpinnerComponent,
  ],
})
export class ConfirmHealthSystemSelectionComponent {
  isCompleting = false;

  constructor(
    public configService: ConfigService,
    private router: Router,
    private fastenService: FastenService,
    private logger: NGXLogger,
    private injector: EnvironmentInjector,
  ) {}

  getAccountInitials(name: string): string {
    const words = name.trim().split(/\s+/).filter(Boolean);

    if (words.length > 1) {
      return `${words[0][0]}${words[1][0]}`;
    }

    return words[0]?.slice(0, 2) || '';
  }

  getAccountLogo(brandId?: string): string {
    if (!brandId || brandId === DEFAULT_SOURCE_LOGO_BRAND_ID) {
      return '';
    }

    return `https://cdn.fastenhealth.com/logos/sources/${brandId}.png`;
  }

  completeAccounts(): void {
    const connectedAccounts = this.configService.vaultProfileConfig$.connectedPatientAccounts || [];
    const tefcaDirectAccounts = connectedAccounts.filter((account) => {
      return (
        account.patient_auth_type === SourceCredentialType.SourceCredentialTypeTefcaDirect ||
        account.patient_auth_type === SourceCredentialType.SourceCredentialTypeMedicareDirect
      );
    });

    this.logger.debug('Direct connected accounts to complete:', tefcaDirectAccounts);

    const vaultConnectionIds = tefcaDirectAccounts
      .map((account) => account.vault_profile_connection_id)
      .filter((id): id is string => !!id);
    const uniqueVaultConnectionIds = Array.from(new Set(vaultConnectionIds));

    if (uniqueVaultConnectionIds.length === 0) {
      void this.router.navigateByUrl('dashboard/complete');
      return;
    }

    this.isCompleting = true;

    this.fastenService.authorizeTefcaDirect(
      uniqueVaultConnectionIds,
      this.configService.systemConfig$.externalId,
    ).subscribe(
      (response) => {
        this.logger.info('Direct authorization response', response);
        this.injector.runInContext(() => {
          ProcessTefcaDirectAuthorizationResults(uniqueVaultConnectionIds, response);
        });
        this.isCompleting = false;
        void this.router.navigateByUrl('dashboard/complete');
      },
      (error) => {
        this.logger.error('Failed to authorize Direct accounts', error);
        this.injector.runInContext(() => {
          ProcessTefcaDirectAuthorizationResults(uniqueVaultConnectionIds, null);
        });
        this.isCompleting = false;
        void this.router.navigateByUrl('dashboard/complete');
      },
    );
  }
}
